<template>
  <module-configuration :data="config" :errors="errors">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="Seller Id">
        <input class="form-input" v-model="config.auth.sellerId">
      </form-group>
      <form-group label="Usuário">
        <input class="form-input" v-model="config.auth.user">
      </form-group>
      <form-group label="Senha">
        <input class="form-input" v-model="config.auth.password">
      </form-group>
    </div>

    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>
        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>
      </div>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel :title="$t('quotation.label')">
      <div class="l-row">
        <form-group label="Ambiente">
          <select v-model="config.quotation.shipmentMethod" class="form-select">
            <option :value=null>{{ $t('choose.label') }}</option>
            <option :value="module.identifier" v-for="module in definitionShipmentsInstalled">{{ $t(`${module.identifier}.label`) }}</option>
          </select>
        </form-group>

        <form-group label="URL">
          {{ urlQuotation }}

          <button type="button" @click="copied()" class="btn btn--sm btn--info copy hint hint--top" data-label="Clique para copiar token" v-clipboard:copy="urlQuotation">
            <i class="icon icon-copy2"></i>
          </button>
        </form-group>
      </div>
    </panel>

    <panel :title="$t('order.label')">
      <order-retrieve-date-configuration :orderConfigs="config.order"/>
    </panel>

  </module-configuration>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'
  import cookie from 'vue-cookie'

  export default {
    inject: ['expeditersDI', 'priceTypeDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'walmart'
      }
    },
    data: () => ({
      errors: [],
      type: 'marketplace',
      identifier: 'walmart',
      config: {
        auth: {
          environment: 'sandbox',
          sellerId: null,
          user: null,
          password: null
        },
        product: {
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          }
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          retrieveDate: null
        },
        quotation: {
          shipmentMethod: null
        }
      }
    }),
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      }
    },
    computed: {
      ...mapGetters('module', [
        'definitionEcommerceInstalled',
        'definitionShipmentsInstalled'
      ]),
      urlQuotation () {
        let url = `https://walmart-fulfillment.placemarket.com.br/${cookie.get('merchant')}`

        if (window.location.hostname === 'localhost') {
          url = `http://localhost:4000/walmart/${cookie.get('merchant')}`
        }

        return url
      }
    },
    components: {
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration,
      OrderRetrieveDateConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// Walmart.vue?507a81c0